@if (data$ | async; as data) {
  <dp-navigation-ui
    [node]="node$ | async"
    [ngClass]="data.styleClass"
    [wrapAfter]="data.wrapAfter"
    [resetMenuOnClose]="data.resetMenuOnClose"
  ></dp-navigation-ui>
}
